// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/organizations.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Questionnaire } from "./questionnaires_pb";
import { file_cortado_v1_questionnaires } from "./questionnaires_pb";
import type { Role } from "./rbac_pb";
import { file_cortado_v1_rbac } from "./rbac_pb";
import type { EventStageEnum, EventTypeEnum, LeadAssignmentModeEnum, OnboardingStepEnum, OrganizationFeatureEnum, QuoteExpirationAnchorEnum, StripeCheckoutPaymentMethodEnum, TipAllocationModeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/organizations.proto.
 */
export const file_cortado_v1_organizations: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_questionnaires, file_cortado_v1_rbac, file_cortado_v1_settings, file_cortado_v1_users, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * OrganizationGalleryImage is one photo in the organization's client portal
 * gallery. Images are served from a public bucket, so public_url is stable and
 * safe to embed. sort_order 0 is the lead photo.
 *
 * @generated from message cortado.v1.OrganizationGalleryImage
 */
export type OrganizationGalleryImage = Message<"cortado.v1.OrganizationGalleryImage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string public_url = 20;
   */
  publicUrl: string;

  /**
   * @generated from field: string filename = 21;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 22;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 23;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional int32 width_px = 24;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 25;
   */
  heightPx?: number;

  /**
   * @generated from field: string alt_text = 26;
   */
  altText: string;

  /**
   * @generated from field: int32 sort_order = 27;
   */
  sortOrder: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 63;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.OrganizationGalleryImage.
 * Use `create(OrganizationGalleryImageSchema)` to create a new message.
 */
export const OrganizationGalleryImageSchema: GenMessage<OrganizationGalleryImage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 0);

/**
 * Organization represents an organization in the system
 *
 * @generated from message cortado.v1.Organization
 */
export type Organization = Message<"cortado.v1.Organization"> & {
  /**
   * Unique identifier for the organization
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Name of the organization
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Logo URL of the organization (optional)
   *
   * @generated from field: optional string logo_url = 3;
   */
  logoUrl?: string;

  /**
   * Website URL of the organization (optional)
   *
   * @generated from field: optional string website_url = 4;
   */
  websiteUrl?: string;

  /**
   * Contact email of the organization (optional)
   *
   * @generated from field: optional string contact_email = 5;
   */
  contactEmail?: string;

  /**
   * Address of the organization (optional)
   *
   * @generated from field: optional string address = 6;
   */
  address?: string;

  /**
   * Stripe account ID of the organization (optional)
   *
   * @generated from field: optional string stripe_account_id = 7;
   */
  stripeAccountId?: string;

  /**
   * Stripe account type of the organization (optional)
   *
   * @generated from field: optional string stripe_account_type = 8;
   */
  stripeAccountType?: string;

  /**
   * Application fee of the organization in percentage for (i.e. 10.00 for 10%) (optional)
   *
   * @generated from field: optional float application_fee = 9;
   */
  applicationFee?: number;

  /**
   * Time settings of the organization (optional)
   *
   * @generated from field: optional cortado.v1.OrganizationTimeSettings time_settings = 10;
   */
  timeSettings?: OrganizationTimeSettings;

  /**
   * Contact fields of the organization
   *
   * @generated from field: repeated cortado.v1.OrganizationContactField contact_fields = 11;
   */
  contactFields: OrganizationContactField[];

  /**
   * Enforced tips of the organization - one per event type
   *
   * @generated from field: repeated cortado.v1.OrganizationEnforcedTip enforced_tips = 12;
   */
  enforcedTips: OrganizationEnforcedTip[];

  /**
   * Created at of the organization (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * Created by of the organization (optional)
   *
   * @generated from field: optional cortado.v1.User created_by = 14;
   */
  createdBy?: User;

  /**
   * Updated at of the organization (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by of the organization (optional)
   *
   * @generated from field: optional cortado.v1.User updated_by = 16;
   */
  updatedBy?: User;

  /**
   * Enabled features for this organization
   *
   * @generated from field: repeated cortado.v1.OrganizationFeature enabled_features = 17;
   */
  enabledFeatures: OrganizationFeature[];

  /**
   * Historical organization slug. Deprecated; not used for public form routing.
   *
   * @generated from field: optional string slug = 18;
   */
  slug?: string;

  /**
   * Google Tag measurement ID for analytics (format: G-XXXXXXXXXX)
   *
   * @generated from field: optional string google_tag_id = 19;
   */
  googleTagId?: string;

  /**
   * Checkout settings for Stripe payment method restrictions
   *
   * @generated from field: optional cortado.v1.OrganizationCheckoutSettings checkout_settings = 20;
   */
  checkoutSettings?: OrganizationCheckoutSettings;

  /**
   * Inventory settings for packing list calculations
   *
   * @generated from field: optional cortado.v1.OrganizationInventorySettings inventory_settings = 21;
   */
  inventorySettings?: OrganizationInventorySettings;

  /**
   * Google Ads conversion label for tracking form submissions
   *
   * @generated from field: optional string google_ads_conversion_label = 22;
   */
  googleAdsConversionLabel?: string;

  /**
   * Email address to CC on inquiry notification emails
   *
   * @generated from field: optional string inquiry_cc_email = 23;
   */
  inquiryCcEmail?: string;

  /**
   * Customizable tip selector settings shown to customers in the portal
   *
   * @generated from field: optional cortado.v1.OrganizationTipSelectorSettings tip_selector_settings = 24;
   */
  tipSelectorSettings?: OrganizationTipSelectorSettings;

  /**
   * Customizable success message shown after the public inquiry form is submitted
   *
   * @generated from field: optional string form_success_message = 25;
   */
  formSuccessMessage?: string;

  /**
   * URL to redirect to after the public inquiry form is submitted (optional).
   * Sent to the embedding parent window via postMessage; the parent decides whether to honor it.
   * When the form is opened standalone (not embedded), the form itself navigates to this URL.
   *
   * @generated from field: optional string form_redirect_url = 26;
   */
  formRedirectUrl?: string;

  /**
   * Whether the org opts into email open tracking via Resend events. Defaults to TRUE.
   *
   * @generated from field: bool track_email_opens = 27;
   */
  trackEmailOpens: boolean;

  /**
   * Theming inputs for the embeddable inquiry form. Unset means the form uses its
   * built-in defaults.
   *
   * @generated from field: optional cortado.v1.FormTheme form_theme = 28;
   */
  formTheme?: FormTheme;

  /**
   * Google Calendar sync policy: which event stages sync, and whether staff
   * are emailed invites. Unset means every non-cancelled stage syncs and staff
   * are not emailed (today's default behavior).
   *
   * @generated from field: optional cortado.v1.CalendarSyncSettings calendar_sync_settings = 29;
   */
  calendarSyncSettings?: CalendarSyncSettings;

  /**
   * Lead assignment policy for new inquiries: unassigned, a single default
   * user, or round robin across an opt-in list of org users. Unset means
   * unassigned (today's default behavior).
   *
   * @generated from field: optional cortado.v1.LeadAssignmentSettings lead_assignment_settings = 30;
   */
  leadAssignmentSettings?: LeadAssignmentSettings;

  /**
   * Default offset days for quote expiration (1-90 after create, 0-365 before
   * event depending on default_quote_expiration_anchor). Defaults to 7 when unset.
   *
   * @generated from field: int32 default_quote_validity_days = 31;
   */
  defaultQuoteValidityDays: number;

  /**
   * How the quote builder computes default valid-until from
   * default_quote_validity_days. Defaults to after_create when unset.
   *
   * @generated from field: cortado.v1.QuoteExpirationAnchorEnum default_quote_expiration_anchor = 34;
   */
  defaultQuoteExpirationAnchor: QuoteExpirationAnchorEnum;

  /**
   * Default number of days after quote acceptance that a 50/50 deposit is due
   * (0-90). 0 means due on acceptance. Used when applying the 50% deposit
   * preset. Defaults to 7 when unset or out of range.
   *
   * @generated from field: int32 default_deposit_due_days_after_acceptance = 32;
   */
  defaultDepositDueDaysAfterAcceptance: number;

  /**
   * Default number of days before the first event date that a 50/50 remainder
   * is due (0-365). 0 means due on the event date. Used when applying the 50%
   * deposit preset. Defaults to 14 when unset or out of range.
   *
   * @generated from field: int32 default_remainder_due_days_before_event = 33;
   */
  defaultRemainderDueDaysBeforeEvent: number;

  /**
   * Default booking questionnaire copied onto every new booking. Event-type
   * questionnaires are appended after these items when present.
   *
   * @generated from field: optional cortado.v1.Questionnaire default_questionnaire = 35;
   */
  defaultQuestionnaire?: Questionnaire;

  /**
   * Default for whether a new inquiry requires a questionnaire.
   *
   * @generated from field: bool default_requires_questionnaire = 37;
   */
  defaultRequiresQuestionnaire: boolean;

  /**
   * When true, customers must answer a booking's required questionnaire
   * questions before they can pay in the portal.
   *
   * @generated from field: bool require_questionnaire_before_payment = 38;
   */
  requireQuestionnaireBeforePayment: boolean;

  /**
   * When true, add-ons on the public inquiry form show their catalog images.
   *
   * @generated from field: bool show_form_addon_images = 39;
   */
  showFormAddonImages: boolean;

  /**
   * IANA timezone identifier (e.g. "America/Chicago") for the organization's
   * default operating timezone. Unset means no org-level default is
   * configured. This is a last-resort fallback for event timezone
   * resolution — geocoded event location still takes precedence.
   *
   * @generated from field: optional string timezone = 36;
   */
  timezone?: string;
};

/**
 * Describes the message cortado.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 1);

/**
 * FormTheme holds the theming inputs for an organization's embeddable inquiry form.
 * Inputs only — the form app derives every concrete color, radius, and font stack
 * client-side.
 *
 * @generated from message cortado.v1.FormTheme
 */
export type FormTheme = Message<"cortado.v1.FormTheme"> & {
  /**
   * Named starting point: classic|modern|warm|elegant|bold|fresh|custom
   *
   * @generated from field: string preset = 1;
   */
  preset: string;

  /**
   * Brand color as a hex string in #RRGGBB format
   *
   * @generated from field: string brand_color = 2;
   */
  brandColor: string;

  /**
   * Font family key, e.g. system|inter|dm-sans|lora
   *
   * @generated from field: string font = 3;
   */
  font: string;

  /**
   * Border radius scale: sharp|soft|round
   *
   * @generated from field: string corner_style = 4;
   */
  cornerStyle: string;

  /**
   * Whether to render the organization's logo at the top of the form
   *
   * @generated from field: bool show_logo = 5;
   */
  showLogo: boolean;
};

/**
 * Describes the message cortado.v1.FormTheme.
 * Use `create(FormThemeSchema)` to create a new message.
 */
export const FormThemeSchema: GenMessage<FormTheme> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 2);

/**
 * CalendarSyncSettings controls which event stages sync to Google Calendar
 * and whether assigned staff are emailed invites.
 *
 * @generated from message cortado.v1.CalendarSyncSettings
 */
export type CalendarSyncSettings = Message<"cortado.v1.CalendarSyncSettings"> & {
  /**
   * Event stages that sync to Google Calendar. Empty = all non-cancelled stages
   * sync (default). Cancelled/archived always delete regardless.
   *
   * @generated from field: repeated cortado.v1.EventStageEnum synced_stages = 1;
   */
  syncedStages: EventStageEnum[];

  /**
   * When true, employees assigned to the event are emailed Google invites/updates.
   *
   * @generated from field: bool invite_staff = 2;
   */
  inviteStaff: boolean;

  /**
   * Go template source for the Google Calendar event description. Empty means
   * the legacy built-in description format is used (today's behavior).
   *
   * @generated from field: string description_template = 3;
   */
  descriptionTemplate: string;
};

/**
 * Describes the message cortado.v1.CalendarSyncSettings.
 * Use `create(CalendarSyncSettingsSchema)` to create a new message.
 */
export const CalendarSyncSettingsSchema: GenMessage<CalendarSyncSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 3);

/**
 * LeadAssignmentSettings controls what happens to new leads (inquiries):
 * left unassigned, assigned to a single default user, or rotated through an
 * opt-in list of organization users.
 *
 * @generated from message cortado.v1.LeadAssignmentSettings
 */
export type LeadAssignmentSettings = Message<"cortado.v1.LeadAssignmentSettings"> & {
  /**
   * @generated from field: cortado.v1.LeadAssignmentModeEnum mode = 1;
   */
  mode: LeadAssignmentModeEnum;

  /**
   * required when mode DEFAULT_USER
   *
   * @generated from field: string default_user_id = 2;
   */
  defaultUserId: string;

  /**
   * ordered opt-in rotation; used when mode ROUND_ROBIN
   *
   * @generated from field: repeated string round_robin_user_ids = 3;
   */
  roundRobinUserIds: string[];
};

/**
 * Describes the message cortado.v1.LeadAssignmentSettings.
 * Use `create(LeadAssignmentSettingsSchema)` to create a new message.
 */
export const LeadAssignmentSettingsSchema: GenMessage<LeadAssignmentSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 4);

/**
 * @generated from message cortado.v1.OrganizationTimeSettings
 */
export type OrganizationTimeSettings = Message<"cortado.v1.OrganizationTimeSettings"> & {
  /**
   * Prep time of the organization in minutes
   *
   * @generated from field: int32 prep_time = 1;
   */
  prepTime: number;

  /**
   * Setup time of the organization in minutes
   *
   * @generated from field: int32 setup_time = 2;
   */
  setupTime: number;

  /**
   * Teardown time of the organization in minutes
   *
   * @generated from field: int32 teardown_time = 3;
   */
  teardownTime: number;
};

/**
 * Describes the message cortado.v1.OrganizationTimeSettings.
 * Use `create(OrganizationTimeSettingsSchema)` to create a new message.
 */
export const OrganizationTimeSettingsSchema: GenMessage<OrganizationTimeSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 5);

/**
 * OrganizationCheckoutSettings contains Stripe Checkout configuration for an organization
 *
 * @generated from message cortado.v1.OrganizationCheckoutSettings
 */
export type OrganizationCheckoutSettings = Message<"cortado.v1.OrganizationCheckoutSettings"> & {
  /**
   * Payment methods enabled for Stripe Checkout sessions
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum enabled_payment_methods = 1;
   */
  enabledPaymentMethods: StripeCheckoutPaymentMethodEnum[];
};

/**
 * Describes the message cortado.v1.OrganizationCheckoutSettings.
 * Use `create(OrganizationCheckoutSettingsSchema)` to create a new message.
 */
export const OrganizationCheckoutSettingsSchema: GenMessage<OrganizationCheckoutSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 6);

/**
 * OrganizationInventorySettings contains inventory calculation configuration
 *
 * @generated from message cortado.v1.OrganizationInventorySettings
 */
export type OrganizationInventorySettings = Message<"cortado.v1.OrganizationInventorySettings"> & {
  /**
   * Maximum drinks served per hour (throughput)
   *
   * @generated from field: int32 max_drinks_per_hour = 1;
   */
  maxDrinksPerHour: number;

  /**
   * Inventory items with per-unit serving capacity
   *
   * @generated from field: repeated cortado.v1.OrganizationInventoryItem items = 2;
   */
  items: OrganizationInventoryItem[];

  /**
   * Buffer percentage to add on top of calculated amounts (0-100)
   *
   * @generated from field: int32 buffer_percentage = 3;
   */
  bufferPercentage: number;

  /**
   * Expected drinks consumed per guest. 0 or unset means "not configured".
   *
   * @generated from field: double drinks_per_guest = 4;
   */
  drinksPerGuest: number;

  /**
   * Snap guest count UP to the nearest multiple of this before calculating. 0 means no snapping.
   *
   * @generated from field: int32 guest_rounding_increment = 5;
   */
  guestRoundingIncrement: number;

  /**
   * Floor applied to the snapped guest count. 0 means no floor.
   *
   * @generated from field: int32 minimum_guests = 6;
   */
  minimumGuests: number;
};

/**
 * Describes the message cortado.v1.OrganizationInventorySettings.
 * Use `create(OrganizationInventorySettingsSchema)` to create a new message.
 */
export const OrganizationInventorySettingsSchema: GenMessage<OrganizationInventorySettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 7);

/**
 * OrganizationTipSelectorSettings controls the tip selector shown to customers in the portal
 *
 * @generated from message cortado.v1.OrganizationTipSelectorSettings
 */
export type OrganizationTipSelectorSettings = Message<"cortado.v1.OrganizationTipSelectorSettings"> & {
  /**
   * Custom tip percentages to display (max 4, each in (0, 100])
   *
   * @generated from field: repeated float custom_percentages = 1;
   */
  customPercentages: number[];

  /**
   * Message displayed when the customer selects "no tip"
   *
   * @generated from field: string no_tip_message = 2;
   */
  noTipMessage: string;

  /**
   * Whether to show the no-tip message when no tip is selected
   *
   * @generated from field: bool show_no_tip_message = 3;
   */
  showNoTipMessage: boolean;

  /**
   * Whether the customer is allowed to enter a custom tip amount
   *
   * @generated from field: bool allow_custom_amount = 4;
   */
  allowCustomAmount: boolean;

  /**
   * Tip percentage preselected for customers. Must be one of custom_percentages.
   * Unset means no default: new invoices start with no tip.
   *
   * @generated from field: optional float default_percentage = 5;
   */
  defaultPercentage?: number;

  /**
   * Default tip allocation mode seeded onto new quotes. UNSPECIFIED means LAST_SCHEDULE.
   *
   * @generated from field: cortado.v1.TipAllocationModeEnum default_tip_allocation_mode = 6;
   */
  defaultTipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.OrganizationTipSelectorSettings.
 * Use `create(OrganizationTipSelectorSettingsSchema)` to create a new message.
 */
export const OrganizationTipSelectorSettingsSchema: GenMessage<OrganizationTipSelectorSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 8);

/**
 * OrganizationInventoryItem represents a single inventory item with serving capacity
 *
 * @generated from message cortado.v1.OrganizationInventoryItem
 */
export type OrganizationInventoryItem = Message<"cortado.v1.OrganizationInventoryItem"> & {
  /**
   * Name of the item (e.g., "Coffee")
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Unit name (e.g., "bag")
   *
   * @generated from field: string unit_name = 2;
   */
  unitName: string;

  /**
   * Unit size description (e.g., "5lbs")
   *
   * @generated from field: string unit_size = 3;
   */
  unitSize: string;

  /**
   * Number of servings per unit (e.g., 150)
   *
   * @generated from field: int32 servings_per_unit = 4;
   */
  servingsPerUnit: number;

  /**
   * Ratio percentage for this item (0-100)
   *
   * @generated from field: int32 ratio_percentage = 5;
   */
  ratioPercentage: number;

  /**
   * Flat number of extra whole units always added to this item's computed quantity
   * (e.g. always pack 1 spare bag of coffee). Independent of the settings-level
   * buffer_percentage, which is a percentage applied to total drink demand.
   *
   * @generated from field: int32 buffer_units = 6;
   */
  bufferUnits: number;

  /**
   * Free-text grouping label for the packing list (e.g. "Coffee", "Milk", "Syrup",
   * "Supply"). Empty means ungrouped.
   *
   * @generated from field: string category = 7;
   */
  category: string;

  /**
   * How the quantity is counted. buffer_units is added in every mode.
   *
   * @generated from field: cortado.v1.InventoryQuantityModeEnum quantity_mode = 8;
   */
  quantityMode: InventoryQuantityModeEnum;

  /**
   * Units per event (FIXED), per cart (PER_CART) or per servings_per_unit
   * guests (PER_GUEST, where 0 means one). Ignored by PER_DRINK.
   *
   * @generated from field: int32 units = 9;
   */
  units: number;
};

/**
 * Describes the message cortado.v1.OrganizationInventoryItem.
 * Use `create(OrganizationInventoryItemSchema)` to create a new message.
 */
export const OrganizationInventoryItemSchema: GenMessage<OrganizationInventoryItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 9);

/**
 * @generated from message cortado.v1.OrganizationContactField
 */
export type OrganizationContactField = Message<"cortado.v1.OrganizationContactField"> & {
  /**
   * Key of the contact field
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Label of the contact field
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Type of the contact field
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * Display order of the contact field
   *
   * @generated from field: int32 display_order = 4;
   */
  displayOrder: number;
};

/**
 * Describes the message cortado.v1.OrganizationContactField.
 * Use `create(OrganizationContactFieldSchema)` to create a new message.
 */
export const OrganizationContactFieldSchema: GenMessage<OrganizationContactField> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 10);

/**
 * @generated from message cortado.v1.OrganizationEnforcedTip
 */
export type OrganizationEnforcedTip = Message<"cortado.v1.OrganizationEnforcedTip"> & {
  /**
   * Event type of the enforced tip
   *
   * @generated from field: cortado.v1.EventTypeEnum event_type = 1 [deprecated = true];
   * @deprecated
   */
  eventType: EventTypeEnum;

  /**
   * Percentage of the enforced tip in percentage for (i.e. 10.00 for 10%)
   *
   * @generated from field: float percentage = 2;
   */
  percentage: number;

  /**
   * Organization-scoped immutable event type key.
   *
   * @generated from field: string event_type_key = 3;
   */
  eventTypeKey: string;
};

/**
 * Describes the message cortado.v1.OrganizationEnforcedTip.
 * Use `create(OrganizationEnforcedTipSchema)` to create a new message.
 */
export const OrganizationEnforcedTipSchema: GenMessage<OrganizationEnforcedTip> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 11);

/**
 * @generated from message cortado.v1.OrganizationOnboarding
 */
export type OrganizationOnboarding = Message<"cortado.v1.OrganizationOnboarding"> & {
  /**
   * Steps of the onboarding
   *
   * @generated from field: repeated cortado.v1.OrganizationOnboardingStep steps = 1;
   */
  steps: OrganizationOnboardingStep[];

  /**
   * Completed steps of the onboarding
   *
   * @generated from field: int32 completed_steps = 2;
   */
  completedSteps: number;

  /**
   * Total steps of the onboarding
   *
   * @generated from field: int32 total_steps = 3;
   */
  totalSteps: number;

  /**
   * Completion rate of the onboarding
   *
   * @generated from field: float completion_rate = 4;
   */
  completionRate: number;

  /**
   * Is completed of the onboarding
   *
   * @generated from field: bool is_completed = 5;
   */
  isCompleted: boolean;
};

/**
 * Describes the message cortado.v1.OrganizationOnboarding.
 * Use `create(OrganizationOnboardingSchema)` to create a new message.
 */
export const OrganizationOnboardingSchema: GenMessage<OrganizationOnboarding> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 12);

/**
 * @generated from message cortado.v1.OrganizationOnboardingStep
 */
export type OrganizationOnboardingStep = Message<"cortado.v1.OrganizationOnboardingStep"> & {
  /**
   * Organization ID of the onboarding step
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Step of the onboarding step
   *
   * @generated from field: cortado.v1.OnboardingStepEnum step = 2;
   */
  step: OnboardingStepEnum;

  /**
   * Step order of the onboarding step
   *
   * @generated from field: int32 step_order = 3;
   */
  stepOrder: number;

  /**
   * Completed of the onboarding step
   *
   * @generated from field: bool completed = 4;
   */
  completed: boolean;

  /**
   * Completed at of the onboarding step
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 5;
   */
  completedAt?: Timestamp;

  /**
   * Created at of the onboarding step
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Created by of the onboarding step
   *
   * @generated from field: cortado.v1.User created_by = 7;
   */
  createdBy?: User;

  /**
   * Updated at of the onboarding step
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by of the onboarding step
   *
   * @generated from field: cortado.v1.User updated_by = 9;
   */
  updatedBy?: User;

  /**
   * Whether the onboarding step is required and cannot be skipped
   *
   * @generated from field: bool required = 10;
   */
  required: boolean;

  /**
   * Whether the onboarding step can be skipped
   *
   * @generated from field: bool skippable = 11;
   */
  skippable: boolean;

  /**
   * When the onboarding step was skipped
   *
   * @generated from field: optional google.protobuf.Timestamp skipped_at = 12;
   */
  skippedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.OrganizationOnboardingStep.
 * Use `create(OrganizationOnboardingStepSchema)` to create a new message.
 */
export const OrganizationOnboardingStepSchema: GenMessage<OrganizationOnboardingStep> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 13);

/**
 * OrganizationFeature represents an enabled feature for an organization
 *
 * @generated from message cortado.v1.OrganizationFeature
 */
export type OrganizationFeature = Message<"cortado.v1.OrganizationFeature"> & {
  /**
   * The feature type
   *
   * @generated from field: cortado.v1.OrganizationFeatureEnum feature = 1;
   */
  feature: OrganizationFeatureEnum;

  /**
   * Whether the feature is enabled
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * When the feature was enabled
   *
   * @generated from field: optional google.protobuf.Timestamp enabled_at = 3;
   */
  enabledAt?: Timestamp;

  /**
   * When the feature expires (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.OrganizationFeature.
 * Use `create(OrganizationFeatureSchema)` to create a new message.
 */
export const OrganizationFeatureSchema: GenMessage<OrganizationFeature> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 14);

/**
 * @generated from message cortado.v1.OrganizationUser
 */
export type OrganizationUser = Message<"cortado.v1.OrganizationUser"> & {
  /**
   * Organization ID of the user
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * User
   *
   * @generated from field: cortado.v1.User user = 2;
   */
  user?: User;

  /**
   * Title of the user
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Email of the user
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * First name of the user
   *
   * @generated from field: string first_name = 5;
   */
  firstName: string;

  /**
   * Last name of the user
   *
   * @generated from field: string last_name = 6;
   */
  lastName: string;

  /**
   * Created at of the user
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Created by of the user
   *
   * @generated from field: cortado.v1.User created_by = 8;
   */
  createdBy?: User;

  /**
   * Updated at of the user
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by of the user
   *
   * @generated from field: cortado.v1.User updated_by = 10;
   */
  updatedBy?: User;

  /**
   * Roles of the user
   *
   * @generated from field: repeated cortado.v1.Role roles = 12;
   */
  roles: Role[];

  /**
   * Effective permission keys across all of the user's roles (Admin/Manage
   * implications already expanded server-side; see enums.ExpandPermissions)
   *
   * @generated from field: repeated string effective_permissions = 13;
   */
  effectivePermissions: string[];

  /**
   * Membership type of the user
   *
   * @generated from field: cortado.v1.OrganizationUserType user_type = 14;
   */
  userType: OrganizationUserType;
};

/**
 * Describes the message cortado.v1.OrganizationUser.
 * Use `create(OrganizationUserSchema)` to create a new message.
 */
export const OrganizationUserSchema: GenMessage<OrganizationUser> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 15);

/**
 * ListMyOrganizationsRequest is sent to retrieve the current user's organizations
 *
 * @generated from message cortado.v1.ListMyOrganizationsRequest
 */
export type ListMyOrganizationsRequest = Message<"cortado.v1.ListMyOrganizationsRequest"> & {
};

/**
 * Describes the message cortado.v1.ListMyOrganizationsRequest.
 * Use `create(ListMyOrganizationsRequestSchema)` to create a new message.
 */
export const ListMyOrganizationsRequestSchema: GenMessage<ListMyOrganizationsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 16);

/**
 * ListMyOrganizationsResponse contains the list of organizations for the authenticated user
 *
 * @generated from message cortado.v1.ListMyOrganizationsResponse
 */
export type ListMyOrganizationsResponse = Message<"cortado.v1.ListMyOrganizationsResponse"> & {
  /**
   * List of organizations the user belongs to
   *
   * @generated from field: repeated cortado.v1.Organization organizations = 1;
   */
  organizations: Organization[];
};

/**
 * Describes the message cortado.v1.ListMyOrganizationsResponse.
 * Use `create(ListMyOrganizationsResponseSchema)` to create a new message.
 */
export const ListMyOrganizationsResponseSchema: GenMessage<ListMyOrganizationsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 17);

/**
 * GetOrganizationRequest is sent to retrieve an organization by ID
 *
 * @generated from message cortado.v1.GetOrganizationRequest
 */
export type GetOrganizationRequest = Message<"cortado.v1.GetOrganizationRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetOrganizationRequest.
 * Use `create(GetOrganizationRequestSchema)` to create a new message.
 */
export const GetOrganizationRequestSchema: GenMessage<GetOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 18);

/**
 * GetOrganizationResponse contains the organization by ID
 *
 * @generated from message cortado.v1.GetOrganizationResponse
 */
export type GetOrganizationResponse = Message<"cortado.v1.GetOrganizationResponse"> & {
  /**
   * The organization by ID
   *
   * @generated from field: cortado.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message cortado.v1.GetOrganizationResponse.
 * Use `create(GetOrganizationResponseSchema)` to create a new message.
 */
export const GetOrganizationResponseSchema: GenMessage<GetOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 19);

/**
 * UpdateOrganizationRequest is sent to update an organization
 *
 * @generated from message cortado.v1.UpdateOrganizationRequest
 */
export type UpdateOrganizationRequest = Message<"cortado.v1.UpdateOrganizationRequest"> & {
  /**
   * ID of the organization to update (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optional fields that can be updated
   * Only fields specified in update_mask will be updated
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string website_url = 3;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string logo_url = 4;
   */
  logoUrl?: string;

  /**
   * @generated from field: optional string contact_email = 5;
   */
  contactEmail?: string;

  /**
   * @generated from field: optional string address = 6;
   */
  address?: string;

  /**
   * @generated from field: optional cortado.v1.OrganizationTimeSettings time_settings = 7;
   */
  timeSettings?: OrganizationTimeSettings;

  /**
   * @generated from field: repeated cortado.v1.OrganizationContactField contact_fields = 8;
   */
  contactFields: OrganizationContactField[];

  /**
   * @generated from field: repeated cortado.v1.OrganizationEnforcedTip enforced_tips = 9;
   */
  enforcedTips: OrganizationEnforcedTip[];

  /**
   * Field mask specifying which fields to update
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 10;
   */
  updateMask?: FieldMask;

  /**
   * Historical organization slug (optional). Not used for public form routing.
   *
   * @generated from field: optional string slug = 11;
   */
  slug?: string;

  /**
   * Google Tag measurement ID for analytics (optional)
   *
   * @generated from field: optional string google_tag_id = 12;
   */
  googleTagId?: string;

  /**
   * Checkout settings for Stripe payment method restrictions (optional)
   *
   * @generated from field: optional cortado.v1.OrganizationCheckoutSettings checkout_settings = 13;
   */
  checkoutSettings?: OrganizationCheckoutSettings;

  /**
   * Inventory settings for packing list calculations (optional)
   *
   * @generated from field: optional cortado.v1.OrganizationInventorySettings inventory_settings = 14;
   */
  inventorySettings?: OrganizationInventorySettings;

  /**
   * Google Ads conversion label for tracking form submissions (optional)
   *
   * @generated from field: optional string google_ads_conversion_label = 15;
   */
  googleAdsConversionLabel?: string;

  /**
   * Email address to CC on inquiry notification emails (optional)
   *
   * @generated from field: optional string inquiry_cc_email = 16;
   */
  inquiryCcEmail?: string;

  /**
   * Customizable tip selector settings (optional)
   *
   * @generated from field: optional cortado.v1.OrganizationTipSelectorSettings tip_selector_settings = 17;
   */
  tipSelectorSettings?: OrganizationTipSelectorSettings;

  /**
   * Customizable success message shown after the public inquiry form is submitted (optional).
   * Field mask path: form_success_message
   *
   * @generated from field: optional string form_success_message = 18;
   */
  formSuccessMessage?: string;

  /**
   * URL to redirect to after public inquiry form submission (optional).
   * Field mask path: form_redirect_url
   *
   * @generated from field: optional string form_redirect_url = 19;
   */
  formRedirectUrl?: string;

  /**
   * Whether the org opts into email open tracking via Resend events (optional).
   * Field mask path: track_email_opens
   *
   * @generated from field: optional bool track_email_opens = 20;
   */
  trackEmailOpens?: boolean;

  /**
   * Theming inputs for the embeddable inquiry form (optional).
   * Field mask path: form_theme
   *
   * @generated from field: optional cortado.v1.FormTheme form_theme = 21;
   */
  formTheme?: FormTheme;

  /**
   * Google Calendar sync policy (optional).
   * Field mask path: calendar_sync_settings
   *
   * @generated from field: optional cortado.v1.CalendarSyncSettings calendar_sync_settings = 22;
   */
  calendarSyncSettings?: CalendarSyncSettings;

  /**
   * Lead assignment policy for new inquiries (optional).
   * Field mask path: lead_assignment_settings
   *
   * @generated from field: optional cortado.v1.LeadAssignmentSettings lead_assignment_settings = 23;
   */
  leadAssignmentSettings?: LeadAssignmentSettings;

  /**
   * Default quote validity in days (optional, 1-90).
   * Field mask path: default_quote_validity_days
   *
   * @generated from field: optional int32 default_quote_validity_days = 24;
   */
  defaultQuoteValidityDays?: number;

  /**
   * Default deposit due offset in days after acceptance (optional, 0-90).
   * Field mask path: default_deposit_due_days_after_acceptance
   *
   * @generated from field: optional int32 default_deposit_due_days_after_acceptance = 25;
   */
  defaultDepositDueDaysAfterAcceptance?: number;

  /**
   * Default remainder due offset in days before the first event (optional, 0-365).
   * Field mask path: default_remainder_due_days_before_event
   *
   * @generated from field: optional int32 default_remainder_due_days_before_event = 26;
   */
  defaultRemainderDueDaysBeforeEvent?: number;

  /**
   * Default quote expiration anchor (optional).
   * Field mask path: default_quote_expiration_anchor
   *
   * @generated from field: optional cortado.v1.QuoteExpirationAnchorEnum default_quote_expiration_anchor = 27;
   */
  defaultQuoteExpirationAnchor?: QuoteExpirationAnchorEnum;

  /**
   * Default booking questionnaire (optional). Field mask path: default_questionnaire.
   * Nil in the mask clears the org default.
   *
   * @generated from field: optional cortado.v1.Questionnaire default_questionnaire = 28;
   */
  defaultQuestionnaire?: Questionnaire;

  /**
   * Default for whether a new inquiry requires a questionnaire (optional).
   * Field mask path: default_requires_questionnaire
   *
   * @generated from field: optional bool default_requires_questionnaire = 30;
   */
  defaultRequiresQuestionnaire?: boolean;

  /**
   * Whether customers must answer the booking questionnaire before paying (optional).
   * Field mask path: require_questionnaire_before_payment
   *
   * @generated from field: optional bool require_questionnaire_before_payment = 31;
   */
  requireQuestionnaireBeforePayment?: boolean;

  /**
   * Whether add-ons on the inquiry form show their catalog images (optional).
   * Field mask path: show_form_addon_images
   *
   * @generated from field: optional bool show_form_addon_images = 32;
   */
  showFormAddonImages?: boolean;

  /**
   * IANA timezone identifier for the organization's default operating
   * timezone (optional). Field mask path: timezone
   *
   * @generated from field: optional string timezone = 29;
   */
  timezone?: string;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationRequest.
 * Use `create(UpdateOrganizationRequestSchema)` to create a new message.
 */
export const UpdateOrganizationRequestSchema: GenMessage<UpdateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 20);

/**
 * UpdateOrganizationResponse contains the updated organization
 *
 * @generated from message cortado.v1.UpdateOrganizationResponse
 */
export type UpdateOrganizationResponse = Message<"cortado.v1.UpdateOrganizationResponse"> & {
  /**
   * The updated organization
   *
   * @generated from field: cortado.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationResponse.
 * Use `create(UpdateOrganizationResponseSchema)` to create a new message.
 */
export const UpdateOrganizationResponseSchema: GenMessage<UpdateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 21);

/**
 * UploadOrganizationLogoRequest is sent to upload a logo for an organization
 *
 * @generated from message cortado.v1.UploadOrganizationLogoRequest
 */
export type UploadOrganizationLogoRequest = Message<"cortado.v1.UploadOrganizationLogoRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Base64 encoded image data (JPEG format)
   *
   * @generated from field: string base64 = 2;
   */
  base64: string;
};

/**
 * Describes the message cortado.v1.UploadOrganizationLogoRequest.
 * Use `create(UploadOrganizationLogoRequestSchema)` to create a new message.
 */
export const UploadOrganizationLogoRequestSchema: GenMessage<UploadOrganizationLogoRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 22);

/**
 * UploadOrganizationLogoResponse contains the uploaded logo URL
 *
 * @generated from message cortado.v1.UploadOrganizationLogoResponse
 */
export type UploadOrganizationLogoResponse = Message<"cortado.v1.UploadOrganizationLogoResponse"> & {
  /**
   * The URL of the uploaded logo
   *
   * @generated from field: string logo_url = 1;
   */
  logoUrl: string;
};

/**
 * Describes the message cortado.v1.UploadOrganizationLogoResponse.
 * Use `create(UploadOrganizationLogoResponseSchema)` to create a new message.
 */
export const UploadOrganizationLogoResponseSchema: GenMessage<UploadOrganizationLogoResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 23);

/**
 * ListOrganizationUsersRequest is sent to list users of an organization
 *
 * @generated from message cortado.v1.ListOrganizationUsersRequest
 */
export type ListOrganizationUsersRequest = Message<"cortado.v1.ListOrganizationUsersRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListOrganizationUsersRequest.
 * Use `create(ListOrganizationUsersRequestSchema)` to create a new message.
 */
export const ListOrganizationUsersRequestSchema: GenMessage<ListOrganizationUsersRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 24);

/**
 * ListOrganizationUsersResponse contains the list of users in an organization
 *
 * @generated from message cortado.v1.ListOrganizationUsersResponse
 */
export type ListOrganizationUsersResponse = Message<"cortado.v1.ListOrganizationUsersResponse"> & {
  /**
   * List of users in the organization
   *
   * @generated from field: repeated cortado.v1.OrganizationUser users = 1;
   */
  users: OrganizationUser[];
};

/**
 * Describes the message cortado.v1.ListOrganizationUsersResponse.
 * Use `create(ListOrganizationUsersResponseSchema)` to create a new message.
 */
export const ListOrganizationUsersResponseSchema: GenMessage<ListOrganizationUsersResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 25);

/**
 * AddUserToOrganizationRequest is sent to add a user to an organization
 *
 * @generated from message cortado.v1.AddUserToOrganizationRequest
 */
export type AddUserToOrganizationRequest = Message<"cortado.v1.AddUserToOrganizationRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Email of the user (creates user if doesn't exist)
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * Title of the user in the organization
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Role IDs to assign to the user
   *
   * @generated from field: repeated string role_ids = 4;
   */
  roleIds: string[];

  /**
   * First name of the user
   *
   * @generated from field: string first_name = 5;
   */
  firstName: string;

  /**
   * Last name of the user
   *
   * @generated from field: string last_name = 6;
   */
  lastName: string;

  /**
   * Membership type. UNSPECIFIED => ADMIN (older web/iOS clients).
   * EVENT_STAFF requires role_ids to be empty.
   *
   * @generated from field: cortado.v1.OrganizationUserType user_type = 7;
   */
  userType: OrganizationUserType;
};

/**
 * Describes the message cortado.v1.AddUserToOrganizationRequest.
 * Use `create(AddUserToOrganizationRequestSchema)` to create a new message.
 */
export const AddUserToOrganizationRequestSchema: GenMessage<AddUserToOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 26);

/**
 * AddUserToOrganizationResponse contains the added organization user
 *
 * @generated from message cortado.v1.AddUserToOrganizationResponse
 */
export type AddUserToOrganizationResponse = Message<"cortado.v1.AddUserToOrganizationResponse"> & {
  /**
   * The added/updated organization user
   *
   * @generated from field: cortado.v1.OrganizationUser user = 1;
   */
  user?: OrganizationUser;
};

/**
 * Describes the message cortado.v1.AddUserToOrganizationResponse.
 * Use `create(AddUserToOrganizationResponseSchema)` to create a new message.
 */
export const AddUserToOrganizationResponseSchema: GenMessage<AddUserToOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 27);

/**
 * UpdateOrganizationUserRequest is sent to update a user in an organization
 *
 * @generated from message cortado.v1.UpdateOrganizationUserRequest
 */
export type UpdateOrganizationUserRequest = Message<"cortado.v1.UpdateOrganizationUserRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * ID of the user to update
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * New title for the user (optional)
   *
   * @generated from field: optional string title = 3;
   */
  title?: string;

  /**
   * Role IDs to assign to the user (replaces existing roles)
   *
   * @generated from field: repeated string role_ids = 4;
   */
  roleIds: string[];

  /**
   * Field mask specifying which fields to update
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 5;
   */
  updateMask?: FieldMask;

  /**
   * New membership type. Honored only when update_mask contains "user_type".
   * -> EVENT_STAFF: role_ids must be empty (all roles revoked).
   * -> ADMIN: role_ids must be non-empty.
   *
   * @generated from field: optional cortado.v1.OrganizationUserType user_type = 6;
   */
  userType?: OrganizationUserType;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationUserRequest.
 * Use `create(UpdateOrganizationUserRequestSchema)` to create a new message.
 */
export const UpdateOrganizationUserRequestSchema: GenMessage<UpdateOrganizationUserRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 28);

/**
 * UpdateOrganizationUserResponse contains the updated organization user
 *
 * @generated from message cortado.v1.UpdateOrganizationUserResponse
 */
export type UpdateOrganizationUserResponse = Message<"cortado.v1.UpdateOrganizationUserResponse"> & {
  /**
   * The updated organization user
   *
   * @generated from field: cortado.v1.OrganizationUser user = 1;
   */
  user?: OrganizationUser;
};

/**
 * Describes the message cortado.v1.UpdateOrganizationUserResponse.
 * Use `create(UpdateOrganizationUserResponseSchema)` to create a new message.
 */
export const UpdateOrganizationUserResponseSchema: GenMessage<UpdateOrganizationUserResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 29);

/**
 * RemoveUserFromOrganizationRequest is sent to remove a user from an organization
 *
 * @generated from message cortado.v1.RemoveUserFromOrganizationRequest
 */
export type RemoveUserFromOrganizationRequest = Message<"cortado.v1.RemoveUserFromOrganizationRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * ID of the user to remove
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message cortado.v1.RemoveUserFromOrganizationRequest.
 * Use `create(RemoveUserFromOrganizationRequestSchema)` to create a new message.
 */
export const RemoveUserFromOrganizationRequestSchema: GenMessage<RemoveUserFromOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 30);

/**
 * RemoveUserFromOrganizationResponse is empty on success
 *
 * @generated from message cortado.v1.RemoveUserFromOrganizationResponse
 */
export type RemoveUserFromOrganizationResponse = Message<"cortado.v1.RemoveUserFromOrganizationResponse"> & {
  /**
   * Success message
   *
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.RemoveUserFromOrganizationResponse.
 * Use `create(RemoveUserFromOrganizationResponseSchema)` to create a new message.
 */
export const RemoveUserFromOrganizationResponseSchema: GenMessage<RemoveUserFromOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 31);

/**
 * CreateOrganizationRequest is sent to create a new organization
 *
 * @generated from message cortado.v1.CreateOrganizationRequest
 */
export type CreateOrganizationRequest = Message<"cortado.v1.CreateOrganizationRequest"> & {
  /**
   * Name of the organization (required)
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Website URL of the organization (optional)
   *
   * @generated from field: optional string website_url = 2;
   */
  websiteUrl?: string;

  /**
   * Contact email of the organization (optional)
   *
   * @generated from field: optional string contact_email = 3;
   */
  contactEmail?: string;
};

/**
 * Describes the message cortado.v1.CreateOrganizationRequest.
 * Use `create(CreateOrganizationRequestSchema)` to create a new message.
 */
export const CreateOrganizationRequestSchema: GenMessage<CreateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 32);

/**
 * CreateOrganizationResponse contains the created organization
 *
 * @generated from message cortado.v1.CreateOrganizationResponse
 */
export type CreateOrganizationResponse = Message<"cortado.v1.CreateOrganizationResponse"> & {
  /**
   * The created organization
   *
   * @generated from field: cortado.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message cortado.v1.CreateOrganizationResponse.
 * Use `create(CreateOrganizationResponseSchema)` to create a new message.
 */
export const CreateOrganizationResponseSchema: GenMessage<CreateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 33);

/**
 * GetOrganizationOnboardingRequest is sent to retrieve onboarding status
 *
 * @generated from message cortado.v1.GetOrganizationOnboardingRequest
 */
export type GetOrganizationOnboardingRequest = Message<"cortado.v1.GetOrganizationOnboardingRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetOrganizationOnboardingRequest.
 * Use `create(GetOrganizationOnboardingRequestSchema)` to create a new message.
 */
export const GetOrganizationOnboardingRequestSchema: GenMessage<GetOrganizationOnboardingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 34);

/**
 * GetOrganizationOnboardingResponse contains the onboarding status
 *
 * @generated from message cortado.v1.GetOrganizationOnboardingResponse
 */
export type GetOrganizationOnboardingResponse = Message<"cortado.v1.GetOrganizationOnboardingResponse"> & {
  /**
   * The onboarding status
   *
   * @generated from field: cortado.v1.OrganizationOnboarding onboarding = 1;
   */
  onboarding?: OrganizationOnboarding;
};

/**
 * Describes the message cortado.v1.GetOrganizationOnboardingResponse.
 * Use `create(GetOrganizationOnboardingResponseSchema)` to create a new message.
 */
export const GetOrganizationOnboardingResponseSchema: GenMessage<GetOrganizationOnboardingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 35);

/**
 * UpdateOnboardingStepRequest is sent to mark a step as complete or incomplete
 *
 * @generated from message cortado.v1.UpdateOnboardingStepRequest
 */
export type UpdateOnboardingStepRequest = Message<"cortado.v1.UpdateOnboardingStepRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * The step to update
   *
   * @generated from field: cortado.v1.OnboardingStepEnum step = 2;
   */
  step: OnboardingStepEnum;

  /**
   * Whether the step is completed
   *
   * @generated from field: bool completed = 3;
   */
  completed: boolean;
};

/**
 * Describes the message cortado.v1.UpdateOnboardingStepRequest.
 * Use `create(UpdateOnboardingStepRequestSchema)` to create a new message.
 */
export const UpdateOnboardingStepRequestSchema: GenMessage<UpdateOnboardingStepRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 36);

/**
 * UpdateOnboardingStepResponse contains the updated onboarding status
 *
 * @generated from message cortado.v1.UpdateOnboardingStepResponse
 */
export type UpdateOnboardingStepResponse = Message<"cortado.v1.UpdateOnboardingStepResponse"> & {
  /**
   * The updated onboarding status
   *
   * @generated from field: cortado.v1.OrganizationOnboarding onboarding = 1;
   */
  onboarding?: OrganizationOnboarding;
};

/**
 * Describes the message cortado.v1.UpdateOnboardingStepResponse.
 * Use `create(UpdateOnboardingStepResponseSchema)` to create a new message.
 */
export const UpdateOnboardingStepResponseSchema: GenMessage<UpdateOnboardingStepResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 37);

/**
 * SkipOnboardingStepRequest is sent to mark a step as skipped
 *
 * @generated from message cortado.v1.SkipOnboardingStepRequest
 */
export type SkipOnboardingStepRequest = Message<"cortado.v1.SkipOnboardingStepRequest"> & {
  /**
   * ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * The step to skip
   *
   * @generated from field: cortado.v1.OnboardingStepEnum step = 2;
   */
  step: OnboardingStepEnum;
};

/**
 * Describes the message cortado.v1.SkipOnboardingStepRequest.
 * Use `create(SkipOnboardingStepRequestSchema)` to create a new message.
 */
export const SkipOnboardingStepRequestSchema: GenMessage<SkipOnboardingStepRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 38);

/**
 * SkipOnboardingStepResponse contains the updated onboarding status
 *
 * @generated from message cortado.v1.SkipOnboardingStepResponse
 */
export type SkipOnboardingStepResponse = Message<"cortado.v1.SkipOnboardingStepResponse"> & {
  /**
   * The updated onboarding status
   *
   * @generated from field: cortado.v1.OrganizationOnboarding onboarding = 1;
   */
  onboarding?: OrganizationOnboarding;
};

/**
 * Describes the message cortado.v1.SkipOnboardingStepResponse.
 * Use `create(SkipOnboardingStepResponseSchema)` to create a new message.
 */
export const SkipOnboardingStepResponseSchema: GenMessage<SkipOnboardingStepResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 39);

/**
 * CheckSlugAvailabilityRequest is sent to check if a slug is available
 *
 * @generated from message cortado.v1.CheckSlugAvailabilityRequest
 */
export type CheckSlugAvailabilityRequest = Message<"cortado.v1.CheckSlugAvailabilityRequest"> & {
  /**
   * The slug to check
   *
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * Organization ID to exclude from check (for updates to own slug)
   *
   * @generated from field: optional string organization_id = 2;
   */
  organizationId?: string;
};

/**
 * Describes the message cortado.v1.CheckSlugAvailabilityRequest.
 * Use `create(CheckSlugAvailabilityRequestSchema)` to create a new message.
 */
export const CheckSlugAvailabilityRequestSchema: GenMessage<CheckSlugAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 40);

/**
 * CheckSlugAvailabilityResponse contains the availability status
 *
 * @generated from message cortado.v1.CheckSlugAvailabilityResponse
 */
export type CheckSlugAvailabilityResponse = Message<"cortado.v1.CheckSlugAvailabilityResponse"> & {
  /**
   * Whether the slug is available
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * Reason: "available", "invalid_format", "blocked_term", "already_taken"
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message cortado.v1.CheckSlugAvailabilityResponse.
 * Use `create(CheckSlugAvailabilityResponseSchema)` to create a new message.
 */
export const CheckSlugAvailabilityResponseSchema: GenMessage<CheckSlugAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 41);

/**
 * AgreementClause represents a single clause within an agreement
 *
 * @generated from message cortado.v1.AgreementClause
 */
export type AgreementClause = Message<"cortado.v1.AgreementClause"> & {
  /**
   * Unique identifier for the clause
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Agreement ID this clause belongs to
   *
   * @generated from field: string agreement_id = 2;
   */
  agreementId: string;

  /**
   * Title of the clause
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Body content of the clause (plain text)
   *
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * Display order for sorting
   *
   * @generated from field: int32 display_order = 5;
   */
  displayOrder: number;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AgreementClause.
 * Use `create(AgreementClauseSchema)` to create a new message.
 */
export const AgreementClauseSchema: GenMessage<AgreementClause> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 42);

/**
 * Agreement represents an organization's agreement (e.g., terms and conditions)
 *
 * @generated from message cortado.v1.Agreement
 */
export type Agreement = Message<"cortado.v1.Agreement"> & {
  /**
   * Unique identifier for the agreement
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the agreement belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Type of agreement (e.g., 'terms_and_conditions', 'privacy_policy')
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * Display name of the agreement
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * Display order for sorting multiple agreements
   *
   * @generated from field: int32 display_order = 5;
   */
  displayOrder: number;

  /**
   * Clauses within this agreement
   *
   * @generated from field: repeated cortado.v1.AgreementClause clauses = 6;
   */
  clauses: AgreementClause[];

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.Agreement.
 * Use `create(AgreementSchema)` to create a new message.
 */
export const AgreementSchema: GenMessage<Agreement> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 43);

/**
 * ListAgreementsRequest is sent to list agreements for an organization
 *
 * @generated from message cortado.v1.ListAgreementsRequest
 */
export type ListAgreementsRequest = Message<"cortado.v1.ListAgreementsRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Filter by agreement type (optional)
   *
   * @generated from field: optional string type = 2;
   */
  type?: string;
};

/**
 * Describes the message cortado.v1.ListAgreementsRequest.
 * Use `create(ListAgreementsRequestSchema)` to create a new message.
 */
export const ListAgreementsRequestSchema: GenMessage<ListAgreementsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 44);

/**
 * ListAgreementsResponse contains the list of agreements
 *
 * @generated from message cortado.v1.ListAgreementsResponse
 */
export type ListAgreementsResponse = Message<"cortado.v1.ListAgreementsResponse"> & {
  /**
   * List of agreements
   *
   * @generated from field: repeated cortado.v1.Agreement agreements = 1;
   */
  agreements: Agreement[];
};

/**
 * Describes the message cortado.v1.ListAgreementsResponse.
 * Use `create(ListAgreementsResponseSchema)` to create a new message.
 */
export const ListAgreementsResponseSchema: GenMessage<ListAgreementsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 45);

/**
 * GetAgreementRequest is sent to retrieve an agreement by ID
 *
 * @generated from message cortado.v1.GetAgreementRequest
 */
export type GetAgreementRequest = Message<"cortado.v1.GetAgreementRequest"> & {
  /**
   * Agreement ID (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetAgreementRequest.
 * Use `create(GetAgreementRequestSchema)` to create a new message.
 */
export const GetAgreementRequestSchema: GenMessage<GetAgreementRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 46);

/**
 * GetAgreementResponse contains the agreement
 *
 * @generated from message cortado.v1.GetAgreementResponse
 */
export type GetAgreementResponse = Message<"cortado.v1.GetAgreementResponse"> & {
  /**
   * The agreement
   *
   * @generated from field: cortado.v1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message cortado.v1.GetAgreementResponse.
 * Use `create(GetAgreementResponseSchema)` to create a new message.
 */
export const GetAgreementResponseSchema: GenMessage<GetAgreementResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 47);

/**
 * CreateAgreementRequest is sent to create a new agreement
 *
 * @generated from message cortado.v1.CreateAgreementRequest
 */
export type CreateAgreementRequest = Message<"cortado.v1.CreateAgreementRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Type of agreement (required, e.g., 'terms_and_conditions')
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * Display name (required)
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Display order (optional, defaults to 0)
   *
   * @generated from field: optional int32 display_order = 4;
   */
  displayOrder?: number;
};

/**
 * Describes the message cortado.v1.CreateAgreementRequest.
 * Use `create(CreateAgreementRequestSchema)` to create a new message.
 */
export const CreateAgreementRequestSchema: GenMessage<CreateAgreementRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 48);

/**
 * CreateAgreementResponse contains the created agreement
 *
 * @generated from message cortado.v1.CreateAgreementResponse
 */
export type CreateAgreementResponse = Message<"cortado.v1.CreateAgreementResponse"> & {
  /**
   * The created agreement
   *
   * @generated from field: cortado.v1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message cortado.v1.CreateAgreementResponse.
 * Use `create(CreateAgreementResponseSchema)` to create a new message.
 */
export const CreateAgreementResponseSchema: GenMessage<CreateAgreementResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 49);

/**
 * UpdateAgreementRequest is sent to update an agreement
 *
 * @generated from message cortado.v1.UpdateAgreementRequest
 */
export type UpdateAgreementRequest = Message<"cortado.v1.UpdateAgreementRequest"> & {
  /**
   * Agreement ID (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Display name (optional)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Display order (optional)
   *
   * @generated from field: optional int32 display_order = 3;
   */
  displayOrder?: number;

  /**
   * Field mask specifying which fields to update
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 4;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateAgreementRequest.
 * Use `create(UpdateAgreementRequestSchema)` to create a new message.
 */
export const UpdateAgreementRequestSchema: GenMessage<UpdateAgreementRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 50);

/**
 * UpdateAgreementResponse contains the updated agreement
 *
 * @generated from message cortado.v1.UpdateAgreementResponse
 */
export type UpdateAgreementResponse = Message<"cortado.v1.UpdateAgreementResponse"> & {
  /**
   * The updated agreement
   *
   * @generated from field: cortado.v1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message cortado.v1.UpdateAgreementResponse.
 * Use `create(UpdateAgreementResponseSchema)` to create a new message.
 */
export const UpdateAgreementResponseSchema: GenMessage<UpdateAgreementResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 51);

/**
 * DeleteAgreementRequest is sent to delete an agreement
 *
 * @generated from message cortado.v1.DeleteAgreementRequest
 */
export type DeleteAgreementRequest = Message<"cortado.v1.DeleteAgreementRequest"> & {
  /**
   * Agreement ID (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteAgreementRequest.
 * Use `create(DeleteAgreementRequestSchema)` to create a new message.
 */
export const DeleteAgreementRequestSchema: GenMessage<DeleteAgreementRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 52);

/**
 * DeleteAgreementResponse confirms the deletion
 *
 * @generated from message cortado.v1.DeleteAgreementResponse
 */
export type DeleteAgreementResponse = Message<"cortado.v1.DeleteAgreementResponse"> & {
  /**
   * Success message
   *
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteAgreementResponse.
 * Use `create(DeleteAgreementResponseSchema)` to create a new message.
 */
export const DeleteAgreementResponseSchema: GenMessage<DeleteAgreementResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 53);

/**
 * CreateAgreementClauseRequest is sent to create a new clause
 *
 * @generated from message cortado.v1.CreateAgreementClauseRequest
 */
export type CreateAgreementClauseRequest = Message<"cortado.v1.CreateAgreementClauseRequest"> & {
  /**
   * Agreement ID (required)
   *
   * @generated from field: string agreement_id = 1;
   */
  agreementId: string;

  /**
   * Title of the clause (required)
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * Body content (required)
   *
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * Display order (optional, defaults to 0)
   *
   * @generated from field: optional int32 display_order = 4;
   */
  displayOrder?: number;
};

/**
 * Describes the message cortado.v1.CreateAgreementClauseRequest.
 * Use `create(CreateAgreementClauseRequestSchema)` to create a new message.
 */
export const CreateAgreementClauseRequestSchema: GenMessage<CreateAgreementClauseRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 54);

/**
 * CreateAgreementClauseResponse contains the created clause
 *
 * @generated from message cortado.v1.CreateAgreementClauseResponse
 */
export type CreateAgreementClauseResponse = Message<"cortado.v1.CreateAgreementClauseResponse"> & {
  /**
   * The created clause
   *
   * @generated from field: cortado.v1.AgreementClause clause = 1;
   */
  clause?: AgreementClause;
};

/**
 * Describes the message cortado.v1.CreateAgreementClauseResponse.
 * Use `create(CreateAgreementClauseResponseSchema)` to create a new message.
 */
export const CreateAgreementClauseResponseSchema: GenMessage<CreateAgreementClauseResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 55);

/**
 * UpdateAgreementClauseRequest is sent to update a clause
 *
 * @generated from message cortado.v1.UpdateAgreementClauseRequest
 */
export type UpdateAgreementClauseRequest = Message<"cortado.v1.UpdateAgreementClauseRequest"> & {
  /**
   * Clause ID (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Title (optional)
   *
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * Body content (optional)
   *
   * @generated from field: optional string body = 3;
   */
  body?: string;

  /**
   * Display order (optional)
   *
   * @generated from field: optional int32 display_order = 4;
   */
  displayOrder?: number;

  /**
   * Field mask specifying which fields to update
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 5;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateAgreementClauseRequest.
 * Use `create(UpdateAgreementClauseRequestSchema)` to create a new message.
 */
export const UpdateAgreementClauseRequestSchema: GenMessage<UpdateAgreementClauseRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 56);

/**
 * UpdateAgreementClauseResponse contains the updated clause
 *
 * @generated from message cortado.v1.UpdateAgreementClauseResponse
 */
export type UpdateAgreementClauseResponse = Message<"cortado.v1.UpdateAgreementClauseResponse"> & {
  /**
   * The updated clause
   *
   * @generated from field: cortado.v1.AgreementClause clause = 1;
   */
  clause?: AgreementClause;
};

/**
 * Describes the message cortado.v1.UpdateAgreementClauseResponse.
 * Use `create(UpdateAgreementClauseResponseSchema)` to create a new message.
 */
export const UpdateAgreementClauseResponseSchema: GenMessage<UpdateAgreementClauseResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 57);

/**
 * DeleteAgreementClauseRequest is sent to delete a clause
 *
 * @generated from message cortado.v1.DeleteAgreementClauseRequest
 */
export type DeleteAgreementClauseRequest = Message<"cortado.v1.DeleteAgreementClauseRequest"> & {
  /**
   * Clause ID (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteAgreementClauseRequest.
 * Use `create(DeleteAgreementClauseRequestSchema)` to create a new message.
 */
export const DeleteAgreementClauseRequestSchema: GenMessage<DeleteAgreementClauseRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 58);

/**
 * DeleteAgreementClauseResponse confirms the deletion
 *
 * @generated from message cortado.v1.DeleteAgreementClauseResponse
 */
export type DeleteAgreementClauseResponse = Message<"cortado.v1.DeleteAgreementClauseResponse"> & {
  /**
   * Success message
   *
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteAgreementClauseResponse.
 * Use `create(DeleteAgreementClauseResponseSchema)` to create a new message.
 */
export const DeleteAgreementClauseResponseSchema: GenMessage<DeleteAgreementClauseResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 59);

/**
 * ReorderAgreementClausesRequest is sent to reorder clauses within an agreement
 *
 * @generated from message cortado.v1.ReorderAgreementClausesRequest
 */
export type ReorderAgreementClausesRequest = Message<"cortado.v1.ReorderAgreementClausesRequest"> & {
  /**
   * Agreement ID (required)
   *
   * @generated from field: string agreement_id = 1;
   */
  agreementId: string;

  /**
   * Ordered list of clause IDs (required)
   *
   * @generated from field: repeated string clause_ids = 2;
   */
  clauseIds: string[];
};

/**
 * Describes the message cortado.v1.ReorderAgreementClausesRequest.
 * Use `create(ReorderAgreementClausesRequestSchema)` to create a new message.
 */
export const ReorderAgreementClausesRequestSchema: GenMessage<ReorderAgreementClausesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 60);

/**
 * ReorderAgreementClausesResponse confirms the reorder
 *
 * @generated from message cortado.v1.ReorderAgreementClausesResponse
 */
export type ReorderAgreementClausesResponse = Message<"cortado.v1.ReorderAgreementClausesResponse"> & {
  /**
   * The updated agreement with reordered clauses
   *
   * @generated from field: cortado.v1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message cortado.v1.ReorderAgreementClausesResponse.
 * Use `create(ReorderAgreementClausesResponseSchema)` to create a new message.
 */
export const ReorderAgreementClausesResponseSchema: GenMessage<ReorderAgreementClausesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 61);

/**
 * GenerateAgreementClausesRequest asks the AI to draft client-portal
 * agreement clauses from the organization's payment/cancellation policy
 * inputs. Generation is not persisted; the caller must save the returned
 * clauses through the existing clause mutations.
 *
 * @generated from message cortado.v1.GenerateAgreementClausesRequest
 */
export type GenerateAgreementClausesRequest = Message<"cortado.v1.GenerateAgreementClausesRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Deposit required, as a percentage of the total (0-100)
   *
   * @generated from field: int32 deposit_percent = 20;
   */
  depositPercent: number;

  /**
   * How many days before the event the final payment is due
   *
   * @generated from field: int32 final_payment_days_before = 21;
   */
  finalPaymentDaysBefore: number;

  /**
   * How many days before the event a cancellation is still permitted
   *
   * @generated from field: int32 cancellation_window_days = 22;
   */
  cancellationWindowDays: number;

  /**
   * Freeform notes describing any other policy details to reflect
   *
   * @generated from field: string notes = 23;
   */
  notes: string;
};

/**
 * Describes the message cortado.v1.GenerateAgreementClausesRequest.
 * Use `create(GenerateAgreementClausesRequestSchema)` to create a new message.
 */
export const GenerateAgreementClausesRequestSchema: GenMessage<GenerateAgreementClausesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 62);

/**
 * GenerateAgreementClausesResponse contains the AI-drafted clauses
 *
 * @generated from message cortado.v1.GenerateAgreementClausesResponse
 */
export type GenerateAgreementClausesResponse = Message<"cortado.v1.GenerateAgreementClausesResponse"> & {
  /**
   * The drafted clauses, in display order
   *
   * @generated from field: repeated cortado.v1.GeneratedClause clauses = 1;
   */
  clauses: GeneratedClause[];
};

/**
 * Describes the message cortado.v1.GenerateAgreementClausesResponse.
 * Use `create(GenerateAgreementClausesResponseSchema)` to create a new message.
 */
export const GenerateAgreementClausesResponseSchema: GenMessage<GenerateAgreementClausesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 63);

/**
 * GeneratedClause is one AI-drafted clause, not yet persisted
 *
 * @generated from message cortado.v1.GeneratedClause
 */
export type GeneratedClause = Message<"cortado.v1.GeneratedClause"> & {
  /**
   * Display order
   *
   * @generated from field: int32 order = 1;
   */
  order: number;

  /**
   * Clause title
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * Clause body content
   *
   * @generated from field: string content = 3;
   */
  content: string;
};

/**
 * Describes the message cortado.v1.GeneratedClause.
 * Use `create(GeneratedClauseSchema)` to create a new message.
 */
export const GeneratedClauseSchema: GenMessage<GeneratedClause> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 64);

/**
 * UnavailableDate represents a single date marked as unavailable for an organization
 *
 * @generated from message cortado.v1.UnavailableDate
 */
export type UnavailableDate = Message<"cortado.v1.UnavailableDate"> & {
  /**
   * Unique identifier for the unavailable date entry
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization the date belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Date in YYYY-MM-DD format
   *
   * @generated from field: string date = 3;
   */
  date: string;

  /**
   * Optional reason or note explaining why the date is unavailable
   *
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.UnavailableDate.
 * Use `create(UnavailableDateSchema)` to create a new message.
 */
export const UnavailableDateSchema: GenMessage<UnavailableDate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 65);

/**
 * ListUnavailableDatesRequest is sent to list unavailable dates for an organization
 *
 * @generated from message cortado.v1.ListUnavailableDatesRequest
 */
export type ListUnavailableDatesRequest = Message<"cortado.v1.ListUnavailableDatesRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListUnavailableDatesRequest.
 * Use `create(ListUnavailableDatesRequestSchema)` to create a new message.
 */
export const ListUnavailableDatesRequestSchema: GenMessage<ListUnavailableDatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 66);

/**
 * ListUnavailableDatesResponse contains the list of unavailable dates
 *
 * @generated from message cortado.v1.ListUnavailableDatesResponse
 */
export type ListUnavailableDatesResponse = Message<"cortado.v1.ListUnavailableDatesResponse"> & {
  /**
   * List of unavailable dates ordered by date ascending
   *
   * @generated from field: repeated cortado.v1.UnavailableDate unavailable_dates = 1;
   */
  unavailableDates: UnavailableDate[];
};

/**
 * Describes the message cortado.v1.ListUnavailableDatesResponse.
 * Use `create(ListUnavailableDatesResponseSchema)` to create a new message.
 */
export const ListUnavailableDatesResponseSchema: GenMessage<ListUnavailableDatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 67);

/**
 * CreateUnavailableDateRequest is sent to create a new unavailable date entry
 *
 * @generated from message cortado.v1.CreateUnavailableDateRequest
 */
export type CreateUnavailableDateRequest = Message<"cortado.v1.CreateUnavailableDateRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Date in YYYY-MM-DD format (required)
   *
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * Optional reason or note
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message cortado.v1.CreateUnavailableDateRequest.
 * Use `create(CreateUnavailableDateRequestSchema)` to create a new message.
 */
export const CreateUnavailableDateRequestSchema: GenMessage<CreateUnavailableDateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 68);

/**
 * CreateUnavailableDateResponse contains the created unavailable date
 *
 * @generated from message cortado.v1.CreateUnavailableDateResponse
 */
export type CreateUnavailableDateResponse = Message<"cortado.v1.CreateUnavailableDateResponse"> & {
  /**
   * The created unavailable date
   *
   * @generated from field: cortado.v1.UnavailableDate unavailable_date = 1;
   */
  unavailableDate?: UnavailableDate;
};

/**
 * Describes the message cortado.v1.CreateUnavailableDateResponse.
 * Use `create(CreateUnavailableDateResponseSchema)` to create a new message.
 */
export const CreateUnavailableDateResponseSchema: GenMessage<CreateUnavailableDateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 69);

/**
 * UpdateUnavailableDateRequest is sent to update an existing unavailable date entry
 *
 * @generated from message cortado.v1.UpdateUnavailableDateRequest
 */
export type UpdateUnavailableDateRequest = Message<"cortado.v1.UpdateUnavailableDateRequest"> & {
  /**
   * Organization ID (required, used for authorization)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Unavailable date ID (required)
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Date in YYYY-MM-DD format (optional)
   *
   * @generated from field: optional string date = 3;
   */
  date?: string;

  /**
   * Reason or note (optional)
   *
   * @generated from field: optional string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message cortado.v1.UpdateUnavailableDateRequest.
 * Use `create(UpdateUnavailableDateRequestSchema)` to create a new message.
 */
export const UpdateUnavailableDateRequestSchema: GenMessage<UpdateUnavailableDateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 70);

/**
 * UpdateUnavailableDateResponse contains the updated unavailable date
 *
 * @generated from message cortado.v1.UpdateUnavailableDateResponse
 */
export type UpdateUnavailableDateResponse = Message<"cortado.v1.UpdateUnavailableDateResponse"> & {
  /**
   * The updated unavailable date
   *
   * @generated from field: cortado.v1.UnavailableDate unavailable_date = 1;
   */
  unavailableDate?: UnavailableDate;
};

/**
 * Describes the message cortado.v1.UpdateUnavailableDateResponse.
 * Use `create(UpdateUnavailableDateResponseSchema)` to create a new message.
 */
export const UpdateUnavailableDateResponseSchema: GenMessage<UpdateUnavailableDateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 71);

/**
 * DeleteUnavailableDateRequest is sent to delete an unavailable date entry
 *
 * @generated from message cortado.v1.DeleteUnavailableDateRequest
 */
export type DeleteUnavailableDateRequest = Message<"cortado.v1.DeleteUnavailableDateRequest"> & {
  /**
   * Organization ID (required, used for authorization)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Unavailable date ID (required)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteUnavailableDateRequest.
 * Use `create(DeleteUnavailableDateRequestSchema)` to create a new message.
 */
export const DeleteUnavailableDateRequestSchema: GenMessage<DeleteUnavailableDateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 72);

/**
 * DeleteUnavailableDateResponse confirms the deletion
 *
 * @generated from message cortado.v1.DeleteUnavailableDateResponse
 */
export type DeleteUnavailableDateResponse = Message<"cortado.v1.DeleteUnavailableDateResponse"> & {
  /**
   * Success message
   *
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteUnavailableDateResponse.
 * Use `create(DeleteUnavailableDateResponseSchema)` to create a new message.
 */
export const DeleteUnavailableDateResponseSchema: GenMessage<DeleteUnavailableDateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_organizations, 73);

/**
 * InventoryQuantityModeEnum says how an inventory item's packing quantity is
 * counted for an event.
 *
 * @generated from enum cortado.v1.InventoryQuantityModeEnum
 */
export enum InventoryQuantityModeEnum {
  /**
   * Treated as PER_DRINK (items saved before quantity modes existed).
   *
   * @generated from enum value: INVENTORY_QUANTITY_MODE_UNSPECIFIED = 0;
   */
  INVENTORY_QUANTITY_MODE_UNSPECIFIED = 0,

  /**
   * ratio_percentage of total drink demand, servings_per_unit drinks per unit.
   *
   * @generated from enum value: INVENTORY_QUANTITY_MODE_PER_DRINK = 1;
   */
  INVENTORY_QUANTITY_MODE_PER_DRINK = 1,

  /**
   * `units` per event whatever its size (e.g. 2 water jugs).
   *
   * @generated from enum value: INVENTORY_QUANTITY_MODE_FIXED = 2;
   */
  INVENTORY_QUANTITY_MODE_FIXED = 2,

  /**
   * `units` per cart on the event. An unset or zero cart count is one cart.
   *
   * @generated from enum value: INVENTORY_QUANTITY_MODE_PER_CART = 3;
   */
  INVENTORY_QUANTITY_MODE_PER_CART = 3,

  /**
   * `units` (0 means one) per servings_per_unit guests (0 means one guest),
   * counted on the guest count after the org's rounding increment and minimum
   * and rounded up to whole units. The settings page's simple view stores
   * "X per 50 guests" as units = X, servings_per_unit = 50.
   *
   * @generated from enum value: INVENTORY_QUANTITY_MODE_PER_GUEST = 4;
   */
  INVENTORY_QUANTITY_MODE_PER_GUEST = 4,
}

/**
 * Describes the enum cortado.v1.InventoryQuantityModeEnum.
 */
export const InventoryQuantityModeEnumSchema: GenEnum<InventoryQuantityModeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_organizations, 0);

/**
 * OrganizationUserType is a membership's type, independent of RBAC roles.
 *
 * @generated from enum cortado.v1.OrganizationUserType
 */
export enum OrganizationUserType {
  /**
   * Treated as ADMIN on input.
   *
   * @generated from enum value: ORGANIZATION_USER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Billed seat; permissions come from custom RBAC roles.
   *
   * @generated from enum value: ORGANIZATION_USER_TYPE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * Unbilled; fixed read-only events scope.
   *
   * @generated from enum value: ORGANIZATION_USER_TYPE_EVENT_STAFF = 2;
   */
  EVENT_STAFF = 2,
}

/**
 * Describes the enum cortado.v1.OrganizationUserType.
 */
export const OrganizationUserTypeSchema: GenEnum<OrganizationUserType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_organizations, 1);

